import classNames from "classnames";

interface ErrorStateProps {
  error: unknown;
  title?: string;
}

export function ErrorState({
  error,
  title = "Something went wrong",
}: ErrorStateProps) {
  if (!error) return null;
  console.error(error);
  const message =
    error instanceof Error ? error.message : "Please try again shortly.";

  return (
    <div className="alert alert-warn">
      <strong>{title}</strong>
      <span>{message}</span>
    </div>
  );
}

interface SkeletonBlockProps {
  height: number;
  width?: number;
  count?: number;
  radius?: number;
  className?: string;
}

export function SkeletonBlock({
  count = 1,
  height,
  radius = 8,
  width,
  className,
}: SkeletonBlockProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          className={classNames("skeleton", className)}
          key={index}
          style={{
            borderRadius: radius,
            height,
            width,
            marginBottom: index === count - 1 ? 0 : 9,
          }}
        />
      ))}
    </>
  );
}

export function StatsSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="stats-row">
      {Array.from({ length: count }).map((_, index) => (
        <div className="stat-card" key={index}>
          <div
            className="skeleton"
            style={{
              borderRadius: 4,
              height: 12,
              marginBottom: 12,
              width: "50%",
            }}
          />
          <div
            className="skeleton"
            style={{
              borderRadius: 4,
              height: 30,
              marginBottom: 8,
              width: "32%",
            }}
          />
          <div
            className="skeleton"
            style={{ borderRadius: 4, height: 12, width: "42%" }}
          />
        </div>
      ))}
    </div>
  );
}
